import { embed } from '@nebula.js/stardust';
// import qlikAppPromise from 'config/qlikApp';
import barchart from '@nebula.js/sn-bar-chart';
import slope from './slope-sn';

import butterfly from './butterfly-sn';
import groupedBar from './groupedBar-sn';
import theme from './sense-theme';

// 2021
import swarm from './swarm-sn';
import bar from './bar-sn';
import donut from './donut-sn';
import bubble from './bubble-sn';
import waffle from './waffle-sn';
import pie from './pie-sn';

// 2022
import swarm2022 from './swarm-sn-2022';
import bar2022 from './bar-sn-2022';
import donut2022 from './donut-sn-2022';
import bubble2022 from './bubble-sn-2022';
import waffle2022 from './waffle-sn-2022';
import pie2022 from './pie-sn-2022';

// 2023
import swarm2023 from './swarm-sn-2023';
import bar2023 from './bar-sn-2023';
import donut2023 from './donut-sn-2023';
import bubble2023 from './bubble-sn-2023';
import waffle2023 from './waffle-sn-2023';
import pie2023 from './pie-sn-2023';

export default async function createNebula(qlikApp) {
  // const qlikApp = await qlikAppPromise();
  const nebula = embed(qlikApp, {
    context: {
      keyboardNavigation: true, // tell Nebula to handle navigation
      theme: 'oimTheme',
      constraints: {
        active: false,
        passive: false,
        select: true,
      },
    },
    themes: [
      {
        id: 'oimTheme',
        load: () => Promise.resolve(theme),
      },
    ],
    types: [
      {
        name: 'swarm2023',
        load: () => Promise.resolve(swarm2023),
      },
      {
        name: 'bar2023',
        load: () => Promise.resolve(bar2023),
      },
      {
        name: 'donut2023',
        load: () => Promise.resolve(donut2023),
      },
      {
        name: 'waffle2023',
        load: () => Promise.resolve(waffle2023),
      },
      {
        name: 'bubble2023',
        load: () => Promise.resolve(bubble2023),
      },
      {
        name: 'pie2023',
        load: () => Promise.resolve(pie2023),
      },
      {
        name: 'swarm2022',
        load: () => Promise.resolve(swarm2022),
      },
      {
        name: 'bar2022',
        load: () => Promise.resolve(bar2022),
      },
      {
        name: 'donut2022',
        load: () => Promise.resolve(donut2022),
      },
      {
        name: 'waffle2022',
        load: () => Promise.resolve(waffle2022),
      },
      {
        name: 'bubble2022',
        load: () => Promise.resolve(bubble2022),
      },
      {
        name: 'pie2022',
        load: () => Promise.resolve(pie2022),
      },
      {
        name: 'swarm',
        load: () => Promise.resolve(swarm),
      },
      {
        name: 'bar',
        load: () => Promise.resolve(bar),
      },
      {
        name: 'donut',
        load: () => Promise.resolve(donut),
      },
      {
        name: 'waffle',
        load: () => Promise.resolve(waffle),
      },
      {
        name: 'bubble',
        load: () => Promise.resolve(bubble),
      },
      {
        name: 'pie',
        load: () => Promise.resolve(pie),
      },
      {
        name: 'slope',
        load: () => Promise.resolve(slope),
      },
      {
        name: 'butterfly',
        load: () => Promise.resolve(butterfly),
      },
      {
        name: 'groupedBar',
        load: () => Promise.resolve(groupedBar),
      },
      {
        name: 'barchart',
        load: () => Promise.resolve(barchart),
      },
    ],
  });
  return nebula;
}
